import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {        
        themes: {
          light: {
            primary: '#eb566b',
            secondary: '#6dc4dd',
            accent: '#8c9eff',
            error: '#b71c1c',
          },
        },
      },
});
